/* eslint-disable */
import cx from 'classnames';
import moment from 'moment';
import changeCase from 'change-object-case';
import { connect } from 'react-redux'
import React, { Component } from 'react';
import { Link } from 'react-router';
import { Button, Form, InputGroup, FormGroup, FormControl, Radio, ControlLabel, HelpBlock, Checkbox, Alert, Modal } from 'react-bootstrap';
import { ss, url, authJsonHeader, mapDispatch, parseTimeString } from '../../utils/util';
import Highlighter from "react-highlight-words";
import FontAwesome from 'react-fontawesome';
import { SITE_DOMAIN } from '../../config';

import './EscapeList.css';
import EscapeForm from './EscapeForm';
import EscapeTeamForm from './EscapeTeamForm';
import EscapeAdder from './EscapeAdder';
import ReviewForm from './ReviewForm';
import ReviewItem from './ReviewItem';
import OmniField from './OmniField';
import WhereField from './WhereField';
import Sharing from './Sharing';
import OzFormComponent from './OzFormComponent';
import OzModalButton from './OzModalButton';
import PercentBar from './PercentBar';
import Loading from './Loading';

import {
  createEscape,
  updateEscape,
  deleteEscape,
  getSuggestions,
  addEscape,
  addTeam,
  createReview,
  updateReview,
  listReviews,
  getProfile,
  getFunFact,
  fetchUser,
  requestVerify,
} from '../../actions';


class InlineAdder extends OzFormComponent {
  state = {
    omniComponentKey: 1
  }

  handleResult(result) {
    console.log('inline adder handle reuslt', result);
    this.setState({
      adding: result,
    }, () => {
      console.log('YES', this.refs.yes);
      this.refs.yes.focus();
    });
  }

  addEscape(didEscape) {
    let room;
    if (this.state.adding) {
      let result = this.state.adding;
      room = {
        roomId: result.id,
      };
    } else {
      room = this.getRoom();
    }

    let escape = {
      didEscape: didEscape,
    };

    let params = { room, escape };
    console.log('sending add escape', params);

    let profile = this.props.profile;
    this.setState({ loading: true });
    this.props.addEscape(params, { silent: true })
      .then(resp => {
        console.log('add escape resp', resp);
        this.props.getFunFact(profile.username, { background: true, silent: true });
        this.props.fetchUser({ silent: true });
        this.props.getProfile(profile.username, { background: true, silent: true })
          .then(resp => {
            this.setState({
              loading: false,
              adding: null,
              manual: false,
              manualRoom: null,
              roomName: '',
              roomCompany: '',
              roomCity: '',
              omniComponentKey: this.state.omniComponentKey + 1,
            });
          });
      });
  }

  renderAdding() {
    let room = this.getRoom();
    return (
      <div className="adding">
        <div className="picked-room">
          <div className="picked-room-name">{room.roomName}</div>
          <div className="picked-room-company">{room.roomCompany}</div>
        </div>

        <div className="did-escape">
          <div className="question">Did you escape?</div>
          <div className="choices">
            <button className="btn" ref="yes" onClick={() => this.addEscape(true)}>Yes</button>
            <button className="btn" onClick={() => this.addEscape(false)}>No</button>
          </div>
        </div>
        {this.state.loading && <div>Adding...</div>}
      </div>
    );
  }

  setWhere(where) {
    console.log('where:', where);
    this.setState({
      roomCity: where.name,
    })
  }

  setManual() {
    this.setState({
      roomId: null,
      room: null,
      manual: true,
      omniComponentKey: this.state.omniComponentKey + 1,
    });
  }

  commitManual() {
    this.setState({
      manualRoom: {
        roomName: this.state.roomName,
        roomCompany: this.state.roomCompany,
        roomCity: this.state.roomCity,
      }
    });
  }

  renderRoomMissing() {
    return (
      <div className="room-missing">
        <div onClick={() => this.setManual()} className="room-missing-inner">
          Can't find it? Add a new room
        </div>
      </div>
    )
  }

  getRoom() {
    if (this.state.manualRoom) {
      return this.state.manualRoom;
    }
    if (this.state.adding) {
      return {
        roomName: this.state.adding.roomName,
        roomCompany: this.state.adding.secondary,
      }
    }
  }

  render() {
    let profile = this.props.profile;
    if (!profile) return null;

    let count = profile.escapes.length;

    let blurb;
    if (count == 0) {
      blurb = 'Add your first escape';
    } else {
      blurb = 'Add more escapes to your profile';
    }

    let enableMaualContinue = (
      this.state.roomName &&
      this.state.roomCompany &&
      this.state.roomCity
    );
    
    let manualRoomForm = (
      <div className="manual">
        <p>Use this form to add a room that's not on EscapeSpy yet.</p>
        {this.renderFormGroup('Room name', 'text', 'roomName')}
        {this.renderFormGroup('Company name', 'text', 'roomCompany')}
        {/*this.renderFormGroup('City', 'text', 'roomCity')*/}
        <FormGroup>
          <ControlLabel>City</ControlLabel>
          <WhereField
            onChange={(where) => this.setWhere(where)}
            onSelect={(where) => this.setWhere(where)}
          />
        </FormGroup>

        <FormGroup className="oz-form-buttons">
          <Button bsStyle="primary" disabled={!enableMaualContinue} onClick={() => this.commitManual()}>Continue</Button>
        </FormGroup>
      </div>
    );

    return (
      <div className="InlineAdder">
        <div className="inner">
          {/*<div className="blurb">{blurb}</div>
          {count == 0 && <div className="help">Start typing an escape room name below to add it to your profile. It's really easy!</div>}
          */}
          <div className="search">
            <OmniField
              focusOnMount
              beforeResults={this.renderRoomMissing()}
              prefill="Find room to add..."
              key={this.state.omniComponentKey}
              showTypes={['rooms']}
              onResult={(result) => this.handleResult(result)}
            />
            {this.getRoom() && this.renderAdding()}
            {!this.getRoom() && this.state.manual && manualRoomForm}
          </div>
        </div>
      </div>
    );
  }
}


export class Escape extends Component {
  constructor(props) {
    super(props);
    let escape = this.props.escape;
    let timeStr = '';
    if (escape.time) {
      timeStr += escape.time;
    }
    if (escape.seconds) {
      timeStr += ':' + escape.seconds;
    }
    this.state = {
      timestr: timeStr,
    };
  }

  updateTime(val) {
    let escape = this.props.escape;
    let r = parseTimeString(val);
    this.setState({ loading: true });

    let save = () => {
      this.props.updateEscape(escape.id, r, { silent: true, didLoad: false })
        .then(resp => {
          this.setState({ loading: false, didLoad: true, escapeOverride: resp.obj });
        });
    };

    if (this.updateTimeTimeoutId) {
      clearTimeout(this.updateTimeTimeoutId);
    }
    this.updateTimeTimeoutId = setTimeout(save, 500);
  }

  addEscapeTeam(e, values) {
    e.preventDefault();
    let profile = this.props.profile;
    console.log('add team for escape:', values);
    this.props.addTeam(values)
      .then(resp => {
        console.log('add escape resp', resp);
        this.setState({ loading: true });
        this.props.getProfile(profile.username, { background: true, silent: true })
          .then(() => {
            this.setState({ addingTeam: false, loading: false });
          });
      });
  }

  renderMiniControls() {
    let review = this.props.review;
    let escape = this.props.escape;
    let profile = this.props.profile;

    if (!escape || !profile) return;

    let addTeamNode;
    if (profile) {
      addTeamNode = (
        <OzModalButton
          modalTitle="Add Team"
          show={this.state.addingTeam}
          onShow={() => this.setState({ addingTeam: true })}
          onHide={() => this.setState({ addingTeam: false })}
          >

          <div className="add-team-btn">
            {!this.state.loading && <Button bsSize="xs"><FontAwesome name="plus-square" /> Add Team</Button>}
            {this.state.loading && <Loading />}
          </div>

          <div>
            <EscapeTeamForm
              modal={true}
              values={{}}
              errors={this.props.errors.addEscapeTeam}
              onCancel={() => this.setState({ addingTeam: false })}
              onSubmit={(e, values) => this.addEscapeTeam(e, values)}
              buttonText="Add Team"
              cancelText="Cancel"
              escape={escape}
              teams={profile.teamMemberships.map(tm => tm.team)}
            />
          </div>
        </OzModalButton>
      );
    }

    return (
      <div className="mini-controls">
        {escape.team && <Link to={'/team/' + escape.team.id}><div className="team">{escape.team.name}</div></Link>}
        {!escape.team && addTeamNode}

        {!review && <Button
         bsSize="xs"
         bsStyle="default"
         onClick={() => this.props.onAddReview(escape)}><FontAwesome name="plus-square" /> Add Review</Button>}{' '}

        {escape.didEscape && <input
          className="set-time"
          type="text"
          placeholder="Time"
          value={this.state.timeStr}
          onChange={(e) => this.updateTime(e.target.value)}
         />}
        <div className="status">
          {this.state.loading && '...'}
          {this.state.didLoad && 'saved!'}
        </div>
      </div>
    )
  }

  setRating(percent) {
    let review = this.props.review;
    let escape = this.props.escape;
    let profile = this.props.profile;
    if (!profile) return null;

    if (!review) {
      let params = {
        profileId: profile.id,
        escapeId: escape.id,
        roomId: escape.room.id,
        percent,
      };
      console.log('ADD REVIEW', params);
      this.setState({
        loadingReview: true,
        overrideShowPercentBar: true,
      });
      this.props.createReview(params, { silent: true })
        .then(resp => {
          console.log('create review resp', resp);
          this.setState({
            loadingReview: false,
          });
        });
    } else {
      this.setState({
        loadingReview: true,
      });
      console.log('update review for', review, percent);
      this.props.updateReview(review.id, { percent }, { silent: true })
        .then(resp => {
          console.log('create review resp', resp);
          this.setState({
            loadingReview: false,
          });
        });
    }
  }

  requestVerify() {
    this.setState({ loadingRequest: true });
    this.props.onRequestVerify(escape.id)
      .then(() => {
        this.setState({
          didRequest: true,
          loadingRequest: false,
        });
      });
  }

  render() {
    let escape = this.state.escapeOverride || this.props.escape;
    let profile = this.props.profile || {};
    let who = this.props.isSelf ? 'You' : (profile.username || '');
    let possessive = this.props.isSelf ? 'Your' : (profile.username + "'s" || '')
    let photoUrl;
    if (escape.photo) {
      photoUrl = escape.photo;
    }

    let review = this.props.review;
    let address;
    if (escape.room.location) {
      if (escape.room.location.city) {
        address = escape.room.location.city.name;
      } else {
        address = escape.room.location.address;
      }
    }

    let showPercentBar = false;
    if (review) {
      showPercentBar = true;
    }
    if (this.props.isSelf && (!review || this.state.overrideShowPercentBar)) {
      showPercentBar = true;
    }

    // TODO: remove
    // showPercentBar = true;

    let showReviewItem = !!review;

    let rankNode;
    let rank = this.props.rank;
    if (rank) {
      rankNode = (
        <div className="rank">
          <div className="rank-inner">
            <FontAwesome name="thumbs-up" />{' '}
            {this.props.isSelf ? 'Your' : profile.username + "'s"} <span className="rank-num">#{rank}</span> rated room
          </div>
        </div>
      );
    }

    let showRequestVerify = (
      this.props.isSelf &&
      !(this.state.didRequest || escape.didRequestVerify)
    );

    let showSentVerify = (
      this.props.isSelf &&
      (this.state.didRequest || escape.didRequestVerify) &&
      !escape.verified
    );

    let showVerified = escape.verified;

    console.log('debug verify:', escape, showRequestVerify, showSentVerify);

    return (
      <div className={cx('Escape', { yes: escape.didEscape, no: !escape.didEscape })}>
        {this.props.loading && <div className="loader"><Loading /></div>}
        <div className="escape-info">
          <div className="room-name">
            <div className="room-name-inner">
              <Link to={'/r/' + escape.room.slug + '/' + escape.room.id}>{showVerified && <span className="verified-check"><FontAwesome name="check-circle" /></span>} {escape.room.name}</Link>
            </div>
            <div>
              {escape.room.location && escape.room.location.company}
              {address && <span>, {address}</span>}
            </div>


            {this.props.isSelf && this.renderMiniControls()}
          </div>
          <div className="escape-outcome">
            {escape.didEscape && <div className="outcome yes">ESCAPED!</div>}
            {!escape.didEscape && <div className="outcome nope">Nope...</div>}
            <div className="escape-time">
              {escape.didEscape && escape.time && <div className="your-time">{escape.time}min{escape.seconds ? ' ' + escape.seconds + 'sec' : ''}</div>}
            </div>
            <div className="escape-date">
              {escape.date && <div>{moment(escape.date, 'YYYY-MM-DD').format('MMM D YYYY')}</div>}
            </div>
            {this.props.isSelf && <div className="escape-buttons">
             <Button
             bsSize="xs"
             bsStyle="default"
             onClick={() => this.props.onRemove(escape.id)}><FontAwesome name="trash" /></Button>{' '}
             <Button
             bsSize="xs"
             bsStyle="default"
             onClick={() => this.props.onEdit(escape.id)}>Edit</Button>
             </div>}

             <div className="escape-buttons request-verify">
               {showRequestVerify &&
                <Button
                bsSize="xs"
                bsStyle="default"
                onClick={() => this.requestVerify()}>
                {(this.state.loadingRequest) && <span><Loading size="small" inline />{' '}</span>}
                Request<br/>Verification
                </Button>}

                {showSentVerify && <span><FontAwesome name="check-circle" /> Sent request to room owner!</span>}
             </div>
          </div>
        </div>

        {showPercentBar && <div className="rating-wrapper">
         <div className="percent-bar"><PercentBar
         size="small"
         onChange={(p) => this.setRating(p)}
         percent={review ? review.percent : null}
         noEdit={!this.props.isSelf}
         />
         {rankNode}
         {showReviewItem && <ReviewItem noByLine noPercentBar review={review} />}
         </div>
         <div className="spinner">{this.state.loadingReview && <Loading size="small" />}</div>
         </div>}
        <div className="escape-photo">
          {photoUrl && <img src={photoUrl} />}
        </div>
      </div>
    );
  }
}

Escape = connect(
  () => { return {} },
  (dispatch) => mapDispatch(dispatch, { deleteEscape }),
)(Escape);


class EscapeList extends Component {

  state = {
    eagerDeletes: {},
    eagerUpdates: {},
  };

  componentDidMount() {
    console.log('did mount', this.props.profile);

    let username;
    if (this.props.profile) {
      this.props.listReviews({ profile: this.props.profile.id });
      username = this.props.profile.username;
    }
    if (!username && this.props.username) {
      username = this.props.username;
    }
    if (username) {
      this.props.getFunFact(username);
    }
  }

  requestVerify(escapeId) {
    return this.props.requestVerify({ escapeId }, { silent: true });
  }

  editEscape(e, values) {
    e.preventDefault();
    this.setState({ savingEdit: true });
    this.props.updateEscape(this.state.editingEscape, values.escape)
      .then(resp => {
        this.setState({ savingEdit: false });
        if (resp.error) return;
        if (this.props.onChange) this.props.onChange();
        let eagerUpdates = Object.assign({}, this.state.eagerUpdates);
        eagerUpdates[resp.obj.id] = resp.obj;
        this.setState({ eagerUpdates });
        this.closeEditEscape();
      });
  }

  closeEditEscape() {
    this.setState({ editingEscape: false });
  }

  renderEditEscape() {
    if (!this.props.user || !this.props.escapes) return null;
    let profile = this.props.user.profile;
    let rooms = this.props.rooms ? this.props.rooms.items : [];
    let escape = {};
    for (let e of this.props.escapes) {
      if (e.id == this.state.editingEscape) {
        escape = e;
      }
    }
    return (
      <Modal show={!!this.state.editingEscape}>
        <Modal.Header closeButton onHide={() => this.closeEditEscape()}>
          <Modal.Title>Edit Escape</Modal.Title>
        </Modal.Header>
        <EscapeForm
          modal={true}
          values={escape}
          errors={this.props.errors.escape}
          onSubmit={(e, values) => this.editEscape(e, values)}
          onCancel={() => this.closeEditEscape()}
          buttonText="Save"
          cancelText="Cancel"
          rooms={rooms}
          getSuggestions={(...args) => this.props.getSuggestions(...args)}
          teamMemberships={profile ? profile.teamMemberships : []}
        />
      </Modal>
    );
  }

  removeEscape(id) {
    if (!confirm('Are you sure you want to remove this escape?')) return;

    this.setState({ deleting: id });

    this.props.deleteEscape(id, { silent: true })
      .then(resp => {
        console.log('delete escape resp', resp);
        let eagerDeletes = Object.assign({}, this.state.eagerDeletes);
        eagerDeletes[id] = true;
        this.setState({ eagerDeletes, deleting: null });
        if (resp.error) return;
        if (this.props.onChange) this.props.onChange();
      });
  }

  closeAddReview() {
    this.setState({ reviewing: false });
  }

  showReviewForm(escape) {
    this.setState({ reviewing: escape });
  }

  addReview(e, values) {
    e.preventDefault();
    console.log('ADD REVIEW', values);
    this.props.createReview(values)
      .then(resp => {
        console.log('create review resp', resp);
        if (resp.error) return;
        this.closeAddReview();
      });
  }

  renderAddReview() {
    let escape = this.state.reviewing;
    if (!escape) return null;
    if (!this.props.user) return null;
    let profile = this.props.user.profile;

    return (
      <Modal show={!!this.state.reviewing}>
        <Modal.Header closeButton onHide={() => this.closeAddReview()}>
          <Modal.Title>Review {escape.room.name}</Modal.Title>
        </Modal.Header>
        <ReviewForm
          modal={true}
          values={{
                  profileId: profile.id,
                  escapeId: escape.id,
                  roomId: escape.room.id,
                  }}
          errors={this.props.errors.review}
          onSubmit={(e, values) => this.addReview(e, values)}
          onCancel={() => this.closeAddReview()}
          buttonText="Add Review"
          cancelText="Cancel"
          room={escape.room}
        />
      </Modal>
    );
  }

  addEscape(e, values) {
    e.preventDefault();
    console.log('ADD ESCAPE:', values);
    this.props.addEscape(values)
      .then(resp => {
        console.log('add escape resp', resp);
        if (resp.error) return;
        if (this.props.onChange) this.props.onChange();
        this.closeAddEscape();
        this.setState({ reviewing: resp });
      });
  }

  closeAddEscape() {
    this.setState({ addingEscape: false });
  }

  renderAddEscape() {
    console.log('USER', this.props.user);
    if (!this.props.user) return null;
    let profile = this.props.user.profile;
    let rooms = this.props.rooms ? this.props.rooms.items : [];
    let values = {};
    if (this.props.team) {
      values.teamId = this.props.team.id;
    }

    return (
      <Modal show={!!this.state.addingEscape}>
        <Modal.Header closeButton onHide={() => this.closeAddEscape()}>
          <Modal.Title>Add Escape</Modal.Title>
        </Modal.Header>
        <EscapeForm
          modal={true}
          values={values}
          errors={this.props.errors.escape}
          onSubmit={(e, values) => this.addEscape(e, values)}
          onCancel={() => this.closeAddEscape()}
          buttonText="Add"
          cancelText="Cancel"
          rooms={rooms}
          getSuggestions={(...args) => this.props.getSuggestions(...args)}
          teamMemberships={profile ? profile.teamMemberships : []}
        />
      </Modal>
    );
  }

  renderEscapes() {
    let escapes = this.props.escapes;
    let profile = this.props.profile;
    if (!escapes) return;
    let reviews = this.props.reviews;

    let sortedEscapes = escapes.sort((a, b) => {
      if (!a.date && !b.date) return b.id - a.id;
      if (a.date && !b.date) return -1;
      if (!a.date && b.date) return 1;
      return b.date.localeCompare(a.date);
    });
    let nodes = sortedEscapes.map(escape => {
      if (this.state.eagerDeletes[escape.id]) {
        return null;
      }

      if (this.state.eagerUpdates[escape.id]) {
        escape = this.state.eagerUpdates[escape.id];
      }

      let review = null;
      if (reviews) {
        for (let r of reviews.items) {
          if (r.roomId == escape.room.id) {
            review = r;
          }
        }
      }
      let rank;
      if (review) {
        rank = 1;
        let numReviews = reviews.items.length;
        for (let r of reviews.items) {
          if (r.percent > review.percent) {
            rank++;
          }
        }

        if (rank > 10 || rank > Math.round(numReviews * .3)) {
          rank = null;
        }
      }

      let deleting = this.state.deleting == escape.id;
      return (
        <div className={cx({ 'deleting-escape': deleting })}>
          {deleting && <div className="loading"><Loading /></div>}
          <Escape
            key={escape.id}
            escape={escape}
            onEdit={(id) => this.setState({ editingEscape: id })}
            onRemove={(id) => this.removeEscape(id)}
            onAddReview={(escape) => this.showReviewForm(escape)}
            onRequestVerify={() => this.requestVerify(escape.id)}
            isSelf={this.props.isSelf}
            profile={profile}
            review={review}
            errors={this.props.errors}
            loading={this.state.editingEscape == escape.id && this.state.savingEdit}
            rank={rank}

            updateEscape={this.props.updateEscape}
            createReview={this.props.createReview}
            updateReview={this.props.updateReview}
            getProfile={this.props.getProfile}
            addTeam={this.props.addTeam}
          />
        </div>
      );
    });
    return (
      <div>
        {profile && nodes.length == 0 && <p>You haven't added any escapes yet...</p>}
        {nodes}
      </div>
    );
  }

  renderInlineAdder() {
    return <InlineAdder
             addEscape={this.props.addEscape}
             profile={this.props.profile}
             getProfile={this.props.getProfile}
             getFunFact={this.props.getFunFact}
             fetchUser={this.props.fetchUser}
           />;
  }

  renderSharing() {
    let profile = this.props.profile;
    console.log('render sharing!', profile);

    if (!profile) return;

    let message;
    let count = profile.escapes.length;
    let plural = count == 1 ? '' : 's';
    if (this.props.isSelf) {
      message = "I've done " + count + " escape room" + plural + ". View them on my profile";
    } else {
      message = profile.username + " has done " + count + " escape room" + plural + ". View their profile";
    }
    let url = SITE_DOMAIN + '/p/' + profile.username;

    return (
      <div className="sharing"><Sharing url={url} message={message} /></div>
    )
  }

  newFunFact() {
    let profile = this.props.profile;
    this.props.getFunFact(profile.username, { background: true });
  }

  renderFunFact() {
    if (!this.props.funFact) return;
    if (!this.props.profile) return;

    let ff = this.props.funFact;

    let pronoun;
    let verb;
    let combined;
    if (this.props.isSelf) {
      pronoun = 'You';
      verb = 'have';
      combined = "You've";
    } else {
      pronoun = this.props.profile.username;
      verb = 'has';
      combined = pronoun + ' has';
    }

    let body = '??';
    switch (ff.fact) {
      case 'percentile':
        body = <div>{pronoun} {verb} more escapes than <b>{ff.percentile}%</b> of users</div>;
        break;
      case 'miles':
        body = <div>{combined} travelled <b>{ff.miles} miles</b> between rooms</div>;
        break;
      case 'time':
        body = <div>{combined} spent <b>{ff.time.minutes} minutes {!!ff.time.seconds && <span>and {ff.time.seconds} seconds</span>}</b> in rooms</div>;
        break;
      case 'cities':
        body = <div>{combined} done rooms in  <b>{ff.count} {ff.count == 1 ? 'city' : 'cities'}</b></div>;
        break;
      case 'countries':
        body = <div>{combined} done rooms in  <b>{ff.count} {ff.count == 1 ? 'country' : 'countries'}</b></div>;
        break;
    }

    return (
      <div className="fun-fact" onClick={() => this.newFunFact()}>{body}</div>
    );
  }

  render() {
    let isSelf = this.props.isSelf;
    let profile = this.props.profile;

    let title = '';
    if (isSelf) {
      title = 'Your Escapes';
    } else if (profile) {
      title = profile.username + "'s Escapes";
    }
      

    return (
      <div className="EscapeList">
        {isSelf && this.renderEditEscape()}

        {this.renderAddReview()}

        <div>
          {isSelf && this.renderInlineAdder()}
          {/*this.renderSharing()*/}

          {this.renderFunFact()}

          <div className="escapes-title">
            {title}
          </div>
          <div className="escapes">
            {this.renderEscapes()}
          </div>
        </div>
      </div>
    );
  }
}


function mapStateToProps(state) {
  return {
    errors: state.errors,
    reviews: state.list.review,
    funFact: state.get.funFact,
  };
}

function mapDispatchToProps(dispatch) {
  return mapDispatch(dispatch, {
    createEscape,
    updateEscape,
    deleteEscape,
    getSuggestions,
    addEscape,
    addTeam,
    createReview,
    updateReview,
    listReviews,
    getProfile,
    getFunFact,
    fetchUser,
    requestVerify,
  });
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EscapeList);



/** WEBPACK FOOTER **
 ** ./src/components/partials/EscapeList.js
 **/